<div #content class="cms-news-view-content" data-test-id="cms-news-view-container">
  @if (details?.videoUrl) {
    <div class="cms-news-view-video" data-test-id="cms-news-view-container-news-video">
      @if (details?.videoUrl) {
        <my7n-video-player
          [articleId]="details?.id"
          [config]="videoPlayerConfig"
          [module]="LogVideoModules.News"
          [title]="details?.title"
          [videoUrl]="details?.videoUrl"
          data-test-id="cms-news-view-container-news-video-player"
        ></my7n-video-player>
      }
    </div>
  }
  @if (details.content) {
    <cms-rich-text
      [content]="details.content"
      class="cms-news-view-details-content"
      data-test-id="cms-news-view-container-news-details-content"
    ></cms-rich-text>
  }
  @if (galleryPhotos$ | async; as gallery) {
    <div class="gallery" data-test-id="news-content-gallery">
      <sharepoint-gallery
        [config]="galleryConfig"
        [items]="gallery.FilesData"
        [newsId]="details.id"
      ></sharepoint-gallery>
    </div>
  }
  <div
    class="cms-news-view-footer flex flex-row flex-between-center"
    data-test-id="cms-news-view-container-news-footer"
  >
    <div
      class="footer-author-container flex max-sm:flex-col sm:gap-24 max-sm:flex-start-start sm:max-md:flex-between-center md:flex-start-center"
    >
      <div class="cms-news-view-footer-author flex flex-start-center md:gap-12">
        <div
          class="cms-news-view-container-footer-author-avatar max-md:hidden"
          data-test-id="cms-news-view-container-news-footer-author-avatar"
        >
          <avatar [avatarUrl]="details.author.avatar" [title]="details.author.fullName"></avatar>
        </div>
        <div class="cms-news-view-footer-author-name-container flex flex-col flex-[1_1_0%]">
          <span class="cms-news-view-footer-author-name" data-test-id="cms-news-view-container-news-footer-author-name">
            {{ details.author.fullName }}
          </span>
        </div>
      </div>

      <div class="cms-news-view-footer-dates flex flex-start-center">
        <mat-icon class="max-md:hidden" svgIcon="calendar_big"></mat-icon>
        @if (details.creationDate) {
          <span
            class="cms-news-view-footer-creation-date"
            data-test-id="cms-news-view-container-news-footer-creation-date"
          >
            {{ details.creationDate | defaultDate: 'minute' : true }}
          </span>
        }
      </div>
    </div>
    <reactions [contentId]="details.id" [contentType]="contentType" data-test-id="reactions"></reactions>
  </div>
</div>
